import { Component, OnInit } from "@angular/core";

@Component({
  templateUrl: "narik-ngx-message-dialog.component.html"
})
export class NarikNgxMessageDialog implements OnInit {
  message: string;
  constructor() {}

  ngOnInit() {}
}
